module.exports = __webpack_public_path__ + "static/media/image-technology-1.b7374057.png";